module.exports = __webpack_public_path__ + "static/media/katia-rosas.9152b591.png";